export let noConnectionTitle = "pVSrNb";
export let noConnectionMessage = "iqLeHb";
export let closeNetworkButtonArialLabel = "jipsDc";
export default {noConnectionTitle,noConnectionMessage,closeNetworkButtonArialLabel};